import { render } from "./excel.vue?vue&type=template&id=2c5dc975&scoped=true"
import script from "./excel.vue?vue&type=script&lang=js"
export * from "./excel.vue?vue&type=script&lang=js"

import "./excel.vue?vue&type=style&index=0&id=2c5dc975&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5dc975"]])

export default __exports__